import PropTypes from 'prop-types';
import React from "react";
import * as rmd from 'material-ui';
import auth from '../auth';
import config from 'cfg';
import { Link } from 'react-router';
import uc from '../styles/images/under_construction.png'
import tw from '../styles/images/tw.png'
import fb from '../styles/images/fb.png'
import st from '../styles/images/st.png'
import et from '../styles/images/edit_theme.png'
import cw from '../styles/images/create_widget.png'
import suggested from '../styles/images/suggested.png'
import getGoogleApiClient from 'google-client-api';
import ContentAdd from 'material-ui/svg-icons/content/add';

class ClientStats extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            users: [],
            isLoading: true
        };

        this.loadData();
    }

    loadData = () => {

        var {user} = this.context;

        if (!user || !user.client) return null;

        return fetch(
            `${config.dash.api
                .host}/api/users?client=${user.client}&access_token=${auth.getAccessToken()}`
        )
            .then(response => response.json())
            .then(body =>
                this.setState({ users: body.users, isLoading: false })
            )
            .catch(err => {
                console.error(err);
                this.setState({ error: err, isLoading: false });
            });
    }

    componentDidMount() {
        var user = this.context.user;

        getGoogleApiClient().then((gapi) => {
            gapi.load('analytics', () => {
                return fetch(`${config.dash.api.host}/api/auth/google/token`)
                    .then(response => response.json())
                    .then(tokens => {
                        gapi.analytics.auth.authorize({
                            'serverAuth': {
                                'access_token': tokens.access_token
                            }
                        });
                        this.buildCharts(user.client, "view-selector-client", "timeline-client");
                        this.state.users.forEach((user, i) => {
                            setTimeout(this.buildCharts.bind(this, "/" + user.username + "/", `view-selector-${user._id}`, `timeline-${user._id}`), i * 300);                           ;
                        });
                    });
            });
        });
    }

    static contextTypes = {
        user: PropTypes.object.isRequired
    }

    render () {
        var user = this.context.user;


        return (
            <div className="home">
                <rmd.Subheader>
                    <div>Hi, {user.username}</div>
                </rmd.Subheader>
                <div className="row">
                    <div className="col-md-12" style={{display: 'block'}} >
                        <rmd.Card className="home-info-card">
                            <rmd.CardTitle
                                title={`${user.client} client stats`.toUpperCase()}
                            />

                            <div id="view-selector-client" style={{display: 'none'}}></div>
                            <div id="timeline-client"></div>
                        </rmd.Card>
                    </div>
                    <rmd.Subheader>
                        <div>Stats per user:</div>
                    </rmd.Subheader>

                    {this.state.users.map(user => {
                        return (
                            <div className="col-md-12" style={{display: 'block'}} >
                                <rmd.Card className="home-info-card">
                                    <rmd.CardTitle
                                        title={`${user.username}`}
                                    />

                                    <div id={`view-selector-${user._id}`} style={{display: 'none'}}></div>
                                    <div id={`timeline-${user._id}`}></div>
                                </rmd.Card>
                            </div>
                        );
                    })}

                </div>
            </div>
        )
    }

    buildCharts = (path, viewSelectorContainer, chartContainer) => {

        var viewSelector = new gapi.analytics.ViewSelector({
            container: viewSelectorContainer
        });
        viewSelector.execute();

        var dataChart = new gapi.analytics.googleCharts.DataChart({
            query: {
                metrics: 'ga:sessions, ga:pageviews, ga:users',
                dimensions: 'ga:date',
                filters: `ga:pagePath=@${path}`,
                'start-date': '30daysAgo',
                'end-date': 'yesterday'
            },
            chart: {
                container: chartContainer,
                type: 'LINE',
                options: {
                    width: '100%'
                }
            }
        });
        viewSelector.on('change', function(ids) {
            var newIds = {
                query: {
                    ids: ids
                }
            }
            dataChart.set(newIds).execute();
        });
    }
}

export default ClientStats;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/ClientSummary.js
 **/